// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"922306ed","423":"8f38e881","488":"2f13bcdd"}[chunkId] + ".chunk.js";
};